import { PodMallUserEntity as UserEntity } from '@mathflat/domain/@entities/PODMall/User/dto'
import { makeAutoObservable } from 'mobx'

import { podMallController } from '@/controller/podMall.controller'

import type { PreOrderFormData } from '../../../PODMallOrder/_service/PreOrderParams'
import { UserParams } from './userParams'

class PODMallUserService {
  user: UserEntity.User | null = null

  constructor() {
    makeAutoObservable(this)
  }

  async fetchSetUser() {
    const data = await podMallController.getUser()
    this.user = new UserEntity.User(data)
  }

  async postUserDeliveryAddress(params: PreOrderFormData) {
    const reqParams = new UserParams({ ...this.user, ...params } as UserEntity.User)
    this.user = { ...this.user, ...params } as UserEntity.User
    await podMallController.postUserDeliveryAddress(reqParams)
  }
}

export const podMallUserService = new PODMallUserService()
